export default "__VITE_ASSET__C7_4FnNH__"